/**
 * A 24px version of the folder-closed icon.
 * The new @atlaskit/icon/core icons only support up to 16px, so we render
 * the same SVG paths at 24px using a custom component.
 */
import React from 'react';

import { token } from '@atlaskit/tokens';

interface FolderClosedIconLargeProps {
	color?: string;
}

export const FolderClosedIconLarge = ({
	color = token('color.icon'),
}: FolderClosedIconLargeProps): React.JSX.Element => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
	>
		<path
			fill={color}
			fillRule="evenodd"
			d="M3 2.5a.5.5 0 0 0-.5.5v3h11V4.75a.5.5 0 0 0-.5-.5H7.69L5.94 2.5zm10.5 5h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM1 3a2 2 0 0 1 2-2h3.56l1.75 1.75H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z"
			clipRule="evenodd"
		/>
	</svg>
);
